export default __webpack_public_path__ + "static/desktop_8-264172300ccfab568d55b3af8608115c.webp";